define((require) => {
    "use strict";

    const {uniq}          = require("underscore");
    const ImprovedView    = require("editor/zbone/ImprovedView");
    const {isBlank, trim} = require("shared/util/StringUtils");
    const template        = require("ui/common/SortingPanel.tpl");

    const FILTER_ATTRIBUTES = {
        project: "This Project",
        all: "All"
    };

    /**
     * View displaying the general sorting options and the search input.
     *
     * @class SortingPanel
     */
    return ImprovedView.extend({

        template,

        templateHelpers() {
            const {sourceEnum, project, showSources} = this.options;
            return {
                sources: showSources && this._sorting && this._sorting.getSourceItems() || [],
                sorting: this._sortingOptions || [],
                filterAttributes: project && FILTER_ATTRIBUTES,
                isScene7: this._currentSource && sourceEnum && this._currentSource === sourceEnum.SCENE7
            };
        },

        className: "sorting-panel",

        events: {
            "click @ui.sourceOptions": "_sourceClickHandler",
            "click @ui.sortingElements": "_sortClickHandler",
            "keyup @ui.searchInput": "_searchKeyupHandler",
            "change @ui.filterSelect": "_filterSelectHandler"
        },

        ui: {
            sourceOptions: "[data-source]",
            sortingElements: "[data-sort]",
            searchInput: ".content-filtering",
            filterSelect: ".filter-attribute"
        },

        _sorting: null,

        _currentSource: null,

        _initialSourceType: null,

        /**
         * @type {ImageLibrarySorting}
         */
        _currentSorting: null,

        _searching: false,

        _searchPhrase: "",

        initialize() {
            this._sorting = this.options.sorting;

            if (this._sorting) {
                this._currentSorting = this._sorting.getSelectedSorting();
                this._currentSource = this._sorting.getSelectedSource();
                this._sortingOptions = this._sorting.getSortingItems();

                if (this.options.initialSource) {
                    this._initialSourceType = this._sorting.getInitialSource(this.options.initialSource);
                }
            }
        },

        toggleFiltering(state) {
            this.$el.toggleClass("project-context", state);
        },

        _sourceClickHandler(event) {
            const clickedSource = event.target.getAttribute("data-source");
            if (clickedSource === this._currentSource) {
                return;
            }
            if (this._sorting) {
                this.setSource(this._sorting.lookupSourceName(clickedSource));
            }
        },

        _showActiveSource(source) {
            this.ui.sourceOptions.removeClass("active");
            this.$el.find("[data-source='" + source.name + "']").addClass("active");
        },

        _showActiveSorting(sorting) {
            this.ui.sortingElements.removeClass("active");
            this.$el.find("[data-sort='" + sorting.name + "']").addClass("active");
        },

        getSource() {
            return this._currentSource;
        },

        getSorting() {
            return this._currentSorting;
        },

        setSource(source, options) {
            if (this._sorting) {
                this._currentSource = source;
                this._sorting.setSelectedSource(this._currentSource);
                this._currentSorting = this._sorting.getSelectedSorting();
                this._sorting.setSelectedSorting(this._currentSorting);
                this._sortingOptions = this._sorting.getSortingItems();
                this._updateSource(options);
            }
        },

        setSorting(sorting) {
            if (this._sorting) {
                this._showActiveSorting(sorting);
                this._sorting.setSelectedSource(this._currentSource);
                this._sorting.setSelectedSorting(sorting);
                this._currentSorting = this._sorting.getSelectedSorting();
            }


            if (this._searching) {
                this._triggerSearch(this._searchPhrase, true);
            } else {
                this.trigger("sort", sorting);
            }
        },

        _updateSource(options) {
            this.trigger("source:changed", this._currentSource, options);
            this._resetSearchState();
            this.trigger("sort", this._currentSorting);
            this.render();
            this._showActiveSource(this._currentSource);
            this._showActiveSorting(this._currentSorting);
        },

        isSearching() {
            return this._searching;
        },

        disable(value) {
            this.$el.toggleClass("disabled", value === true || value === undefined);
        },

        onShow() {
            if (this._initialSourceType && this._currentSource !== this._initialSourceType) {
                this.setSource(this._initialSourceType, {ignoreEditorEvent: true});
            } else {
                this.setSource(this._currentSource);
            }
        },

        _triggerSearch(searchString, forceTrigger = false) {
            if (searchString === this._searchPhrase && !forceTrigger) {
                return;
            }

            // If user clears the input field, reset to current sorting.
            if (isBlank(searchString)) {
                this._resetSearchState();
                this.setSorting(this._currentSorting);
                return;
            }

            this._searchPhrase = searchString;

            this._searching = true;

            // Split phrase into "tags", filtering out duplicates
            const uniqueTags = uniq(this._searchPhrase.split(/\s+/));

            // Signal that we're searching...
            this.trigger("search", uniqueTags, this._currentSorting, this._currentSource);
        },

        _filterSelectHandler() {
            const selected = this.ui.filterSelect.find("option:selected");
            this.trigger("select", selected.text(), selected.val());
        },

        _searchKeyupHandler(event) {
            const searchString = trim(event.target.value);
            this._triggerSearch(searchString);
        },

        _sortClickHandler(event) {
            const sorting = event.target.getAttribute("data-sort");

            if (sorting === this._currentSorting.name && !this._searching) {
                return;
            }

            if (this._sorting) {
                this.setSorting(this._sorting.lookupSortingName(sorting, this._currentSource));
            }
        },

        _resetSearchState() {
            this.ui.searchInput.val("");
            this._searching = false;
            this._searchPhrase = "";
        }

    }, {
        FILTER_ATTRIBUTES
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/common/SortingPanel.js